import React, { useEffect, useRef } from "react";
import "./NorthArrow.css";

// NorthArrow rotates smoothly in sync with the map's bearing using the map's render loop
// Plus: a 1s interval fallback for cases where initial events don't fire in fresh tabs
const NorthArrow = ({ mapRef }) => {
  const arrowRef = useRef(null);

  useEffect(() => {
    let rafId = null;
    let intervalId = null;
    let renderListenerAttached = false;
    let map = null;

    const getMap = () => (mapRef && mapRef.current) || (typeof window !== "undefined" ? window.mapInstance : null);

    const updateRotation = () => {
      if (!arrowRef.current) return;
      const m = getMap();
      if (!m || !m.getBearing) return;
      map = m; // cache latest map instance
      const bearing = m.getBearing();
      arrowRef.current.style.transform = `rotate(${-bearing}deg)`; // Counter-rotate to point north
    };

    const onRender = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(updateRotation);
    };

    const attachListeners = () => {
      if (!map) map = getMap();
      if (!map || !map.on || renderListenerAttached) return;
      updateRotation();
      map.on("render", onRender); // smooth sync during gestures/animations
      map.on("rotate", updateRotation); // event-based backup
      renderListenerAttached = true;
    };

    const tryAttach = () => {
      map = getMap();
      if (!map) {
        rafId = requestAnimationFrame(tryAttach);
        return;
      }
      // Attach immediately if style is loaded; otherwise wait for load
      if ((map.isStyleLoaded && map.isStyleLoaded()) || (map.loaded && map.loaded())) {
        attachListeners();
      } else if (map.once) {
        map.once("load", attachListeners);
      } else {
        rafId = requestAnimationFrame(tryAttach);
      }
    };

    // Begin attach attempts
    tryAttach();

    // 1-second polling fallback requested by user
    intervalId = window.setInterval(() => {
      updateRotation();
      // If for any reason listeners were not attached yet, try again
      if (!renderListenerAttached) attachListeners();
    }, 1000);

    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      if (intervalId) clearInterval(intervalId);
      if (map && map.off) {
        map.off("render", onRender);
        map.off("rotate", updateRotation);
      }
    };
  }, [mapRef]);

  const handleClick = () => {
    // Reset map bearing to north when clicked
    const map = (mapRef && mapRef.current) || (typeof window !== "undefined" ? window.mapInstance : null);
    if (map?.easeTo) map.easeTo({ bearing: 0, duration: 500 });
  };

  return (
    <div
      className="north-arrow-container"
      onClick={handleClick}
      title="اضغط لإعادة توجيه الخريطة للشمال / Click to reset map to north"
    >
      <div className="north-arrow-icon" ref={arrowRef}>
        <img src="/map_controls/RealMap North white v2.png" alt="North Arrow" />
      </div>
    </div>
  );
};

export default NorthArrow;
